function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Calendar = function Calendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M15.987 1a1 1 0 0 1 1 1v.644h2.933c1.654 0 3 1.346 3 3V19.77c0 1.655-1.346 3-3 3H4c-1.654 0-3-1.345-3-3V5.646c0-1.654 1.346-3 3-3l2.933-.001V2a1 1 0 1 1 2 0v.644h6.054V2a1 1 0 0 1 1-1m4.933 9.123H3v9.647c0 .55.449 1 1 1h15.92c.552 0 1-.45 1-1zM6.634 16.825c.69 0 1.25.556 1.25 1.243 0 .686-.56 1.243-1.25 1.243s-1.25-.557-1.25-1.243c0-.687.56-1.243 1.25-1.243m5.348 0c.69 0 1.25.556 1.25 1.243 0 .686-.56 1.243-1.25 1.243s-1.25-.557-1.25-1.243c0-.687.56-1.243 1.25-1.243m5.347 0c.69 0 1.25.556 1.25 1.243 0 .686-.56 1.243-1.25 1.243s-1.25-.557-1.25-1.243c0-.687.56-1.243 1.25-1.243m-10.69-4.79c.69 0 1.25.557 1.25 1.243 0 .687-.56 1.243-1.25 1.243s-1.25-.556-1.25-1.243c0-.686.56-1.243 1.25-1.243m5.347 0c.69 0 1.25.557 1.25 1.243 0 .687-.56 1.243-1.25 1.243s-1.25-.556-1.25-1.243c0-.686.56-1.243 1.25-1.243m5.348 0c.69 0 1.25.557 1.25 1.243 0 .687-.56 1.243-1.25 1.243s-1.25-.556-1.25-1.243c0-.686.56-1.243 1.25-1.243M6.933 4.644H4c-.551 0-1 .45-1 1v2.479h17.92V5.645c0-.551-.448-1-1-1l-2.933-.001v.839a1 1 0 1 1-2 0v-.84H8.933v.84a1 1 0 0 1-2 0z"
  }));
};
export default Calendar;